import styled from "styled-components";
import { Box } from "@mui/material";
import ProfileLayout from "../../layouts/ProfileLayout/ProfileLayout";

export const BlogDetailsPageContainer = styled(Box)`
  margin-top: 80px;
`;

export const Layout = styled(ProfileLayout)``;
